import { useSearchParams } from "react-router-dom";

const PERIODS = [7, 14, 28];

/** The report period lives in the URL (?days=14) so a link reopens the same report. */
export const usePeriodParam = (fallback = 28) => {
  const [params, setParams] = useSearchParams();
  const raw = Number(params.get("days"));
  const days = PERIODS.includes(raw) ? raw : fallback;
  const setDays = (value) =>
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("days", String(value));
        return next;
      },
      { replace: true },
    );
  return [days, setDays];
};
